"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SpecialHoursAPI {
    client;
    constructor(client) {
        this.client = client;
    }
    async getSpecialHours(locationId, limit = 100) {
        return await this.client.get(`locations/${locationId}/special-hours?limit=${limit}`);
    }
    async createSpecialHours(specialHours) {
        return await this.client.post(`locations/${specialHours.locationId}/special-hours`, specialHours);
    }
    async updateSpecialHours(specialHoursId, update) {
        return await this.client.patch(`locations/${update.locationId}/special-hours/${specialHoursId}`, update);
    }
    async deleteSpecialHours(locationId, specialHoursId) {
        return await this.client.delete(`locations/${locationId}/special-hours/${specialHoursId}`);
    }
}
exports.default = SpecialHoursAPI;
//# sourceMappingURL=index.js.map